// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { dbHelpers } from '../../db/database';
// import { ordersAPI, warehousesAPI } from '../../api';
// import { useOfflineData } from '../../hooks/useOfflineData';
// import { usePermissions, filterWarehouses } from '../../utils/permissions';
// import { useModal } from '../../hooks/useModal';
// import Modal from '../common/Modal';
// import './OrdersList.css';

// function OrdersList() {
//   const navigate = useNavigate();
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [deleting, setDeleting] = useState(null);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
  
//   const { isOpen, modalConfig, openModal, closeModal } = useModal();
//   const { canCreate, canEdit, canDelete } = usePermissions('orders');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
  
//   const { data: allOrders, loading: ordersLoading, refetch: refetchOrders } = useOfflineData(
//   () => ordersAPI.getAll(),
//   dbHelpers.getOrders,
//   dbHelpers.saveOrders
// );
  
//   // Load warehouses using hook
//  const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
//   () => warehousesAPI.getAll(),
//   dbHelpers.getWarehouses,
//   dbHelpers.saveWarehouses  
// );
//   const loading = ordersLoading || warehousesLoading;
  
//   // Filter orders by accessible warehouses
//   const accessibleWarehouses = filterWarehouses(allWarehouses);
//   const accessibleWarehouseIds = accessibleWarehouses.map(w => w.id);
  
//   const orders = allOrders.filter(order => 
//     accessibleWarehouseIds.includes(order.warehouse_id || order.warehouse)
//   );

//   function formatDate(dateValue) {
//     if (!dateValue) return 'N/A';
    
//     try {
//       let date;
//       if (typeof dateValue === 'string') {
//         date = new Date(dateValue);
//       } else if (typeof dateValue === 'number') {
//         date = new Date(dateValue);
//       } else {
//         date = dateValue;
//       }
      
//       if (isNaN(date.getTime())) {
//         return 'Invalid Date';
//       }
      
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric'
//       });
//     } catch (error) {
//       return 'N/A';
//     }
//   }

//   function getFilteredOrders() {
//     let filtered = orders;
    
//     if (statusFilter !== 'all') {
//       filtered = filtered.filter(o => o.status === statusFilter);
//     }
    
//     if (searchTerm) {
//       filtered = filtered.filter(o => 
//         o.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         o.customer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         o.id?.toString().includes(searchTerm)
//       );
//     }
    
//     return filtered;
//   }

//   async function performDelete(order) {
//     setDeleting(order.id);
//     setError('');
//     setSuccess('');
    
//     try {
//       await ordersAPI.delete(order.id);
//       await dbHelpers.deleteOrder(order.id);
      
//       // Trigger refresh
//       setRefreshTrigger(prev => prev + 1);
      
//       closeModal();
      
//     setTimeout(() => window.location.reload(), 50);
//     } catch (error) {
//       setError('Failed to delete order', error);
//     } finally {
//       setDeleting(null);
//     }
//   }

//   function handleDelete(order) {
//     openModal({
//       title: 'Delete Order?',
//       message: `Are you sure you want to delete order #${String(order.id).substring(0, 8)} for ${order.customer_name}? This action cannot be undone.`,
//       type: 'danger',
//       confirmText: 'Delete Order',
//       cancelText: 'Cancel',
//       onConfirm: () => performDelete(order)
//     });
//   }

//   function handleEdit(order) {
//     navigate(`/orders/edit/${order.id}`);
//   }

//   const filteredOrders = getFilteredOrders();

//   if (loading) {
//     return (
//       <div className="loading-screen">
//         <div className="spinner"></div>
//         <p>Loading orders...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="orders-list fade-in">
//       <div className="orders-header">
//         <div>
//           <h1>Orders</h1>
//           <p className="subtitle">{orders.length} total orders</p>
//         </div>
        
//         {canCreate && (
//           <button onClick={() => navigate('/orders/new')} className="btn-primary-small">
//             ➕ New Order
//           </button>
//         )}
//       </div>

//       <div className="orders-controls">
//         <input
//           type="text"
//           className="search-input"
//           placeholder="🔍 Search orders..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
        
//         <div className="filter-tabs">
//           <button 
//             className={statusFilter === 'all' ? 'tab active' : 'tab'}
//             onClick={() => setStatusFilter('all')}
//           >
//             All ({orders.length})
//           </button>
//           <button 
//             className={statusFilter === 'pending' ? 'tab active' : 'tab'}
//             onClick={() => setStatusFilter('pending')}
//           >
//             Pending
//           </button>
//           <button 
//             className={statusFilter === 'confirmed' ? 'tab active' : 'tab'}
//             onClick={() => setStatusFilter('confirmed')}
//           >
//             Confirmed
//           </button>
//           <button 
//             className={statusFilter === 'shipped' ? 'tab active' : 'tab'}
//             onClick={() => setStatusFilter('shipped')}
//           >
//             Shipped
//           </button>
//           <button 
//             className={statusFilter === 'delivered' ? 'tab active' : 'tab'}
//             onClick={() => setStatusFilter('delivered')}
//           >
//             Delivered
//           </button>
//         </div>
//       </div>

//       {filteredOrders.length === 0 ? (
//         <div className="empty-state">
//           <div className="empty-icon">📋</div>
//           <p className="empty-title">No orders found</p>
//           <p className="empty-desc">
//             {canCreate 
//               ? 'Create your first order to get started'
//               : 'No orders available'}
//           </p>
//           {canCreate && (
//             <button onClick={() => navigate('/orders/new')} className="btn-primary" style={{marginTop: '20px'}}>
//               ➕ Create Order
//             </button>
//           )}
//         </div>
//       ) : (
//         <div className="orders-table-container">
//           <table className="orders-table">
//             <thead>
//               <tr>
//                 <th>Order ID</th>
//                 <th>Customer</th>
//                 <th>Date</th>
//                 <th>Total</th>
//                 <th>Status</th>
//                 {/* <th>Sync</th> */}
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredOrders.map(order => (
//                 <tr key={order.id}>
//                   <td className="order-id">#{String(order.id).substring(0, 8)}</td>
//                   <td>{order.customer_name || 'N/A'}</td>
//                   <td>{formatDate(order.order_date)}</td>
//                   <td>TSh {parseFloat(order.total || 0).toFixed(2)}</td>
//                   <td>
//                     <span className={`status-badge status-${order.status}`}>
//                       {order.status}
//                     </span>
//                   </td>
//                   {/* <td>
//                     {order.synced ? (
//                       <span className="sync-badge synced">✅ Synced</span>
//                     ) : (
//                       <span className="sync-badge pending">⏳ Pending</span>
//                     )}
//                   </td> */}
//                   <td>
//                     <div style={{display: 'flex', gap: '8px'}}>
//                       <button 
//                         className="btn-action-small" 
//                         onClick={() => navigate(`/orders/${order.id}`)}
//                       >
//                         View
//                       </button>
                      
//                       {canEdit && order.status === 'pending' && (
//                         <button 
//                           className="btn-action-small"
//                           onClick={() => handleEdit(order)}
//                         >
//                           Edit
//                         </button>
//                       )}
                      
//                       {canDelete && (
//                         <button 
//                           className="btn-action-small btn-delete"
//                           onClick={() => handleDelete(order)}
//                           disabled={deleting === order.id}
//                         >
//                           {deleting === order.id ? '⏳' : '🗑️'}
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Confirmation Modal */}
//       <Modal 
//         isOpen={isOpen}
//         onClose={closeModal}
//         {...modalConfig}
//       />
//     </div>
//   );
// }

// export default OrdersList;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dbHelpers } from '../../db/database';
import { ordersAPI, warehousesAPI } from '../../api';
import { useOfflineData } from '../../hooks/useOfflineData';
import { usePermissions, filterWarehouses } from '../../utils/permissions';
import { useModal } from '../../hooks/useModal';
import { useToast } from '../../hooks/useToast';
import Modal from '../common/Modal';
import './OrdersList.css';

function OrdersList() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [deleting, setDeleting] = useState(null);

  const { isOpen, modalConfig, openModal, closeModal } = useModal();
  const { canCreate, canEdit, canDelete } = usePermissions('orders');
  const toast = useToast();

  const { data: allOrders, loading: ordersLoading } = useOfflineData(
    () => ordersAPI.getAll(),
    dbHelpers.getOrders,
    dbHelpers.saveOrders
  );

  const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
    () => warehousesAPI.getAll(),
    dbHelpers.getWarehouses,
    dbHelpers.saveWarehouses
  );

  const loading = ordersLoading || warehousesLoading;

  const accessibleWarehouses = filterWarehouses(allWarehouses);
  const accessibleWarehouseIds = accessibleWarehouses.map(w => w.id);

  // ✅ Local orders state so we can remove items without reload
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const filtered = allOrders.filter(order =>
      accessibleWarehouseIds.includes(order.warehouse_id || order.warehouse)
    );
    setOrders(filtered);
  }, [allOrders, allWarehouses]);

  function formatDate(dateValue) {
    if (!dateValue) return 'N/A';
    try {
      const date = typeof dateValue === 'string' || typeof dateValue === 'number'
        ? new Date(dateValue)
        : dateValue;
      if (isNaN(date.getTime())) return 'Invalid Date';
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
      return 'N/A';
    }
  }

  function getFilteredOrders() {
    let filtered = orders;
    if (statusFilter !== 'all') {
      filtered = filtered.filter(o => o.status === statusFilter);
    }
    if (searchTerm) {
      filtered = filtered.filter(o =>
        o.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        o.customer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        o.id?.toString().includes(searchTerm)
      );
    }
    return filtered;
  }

  async function performDelete(order) {
    setDeleting(order.id);

    try {
      await ordersAPI.delete(order.id);
      await dbHelpers.deleteOrder(order.id);

      // ✅ Remove from local state directly — no reload needed
      setOrders(prev => prev.filter(o => o.id !== order.id));
      closeModal();
      toast.success('✅ Order deleted successfully');
    } catch (err) {
      console.error(err);
      toast.error('Failed to delete order. Please try again.');
    } finally {
      setDeleting(null);
    }
  }

  function handleDelete(order) {
    openModal({
      title: 'Delete Order?',
      message: `Are you sure you want to delete order #${String(order.id).substring(0, 8)} for ${order.customer_name}? This action cannot be undone.`,
      type: 'danger',
      confirmText: 'Delete Order',
      cancelText: 'Cancel',
      onConfirm: () => performDelete(order)
    });
  }

  function handleEdit(order) {
    navigate(`/orders/edit/${order.id}`);
  }

  const filteredOrders = getFilteredOrders();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading orders...</p>
      </div>
    );
  }

  return (
    <div className="orders-list fade-in">
      <div className="orders-header">
        <div>
          <h1>Orders</h1>
          <p className="subtitle">{orders.length} total orders</p>
        </div>
        {canCreate && (
          <button onClick={() => navigate('/orders/new')} className="btn-primary-small">
            ➕ New Order
          </button>
        )}
      </div>

      <div className="orders-controls">
        <input
          type="text"
          className="search-input"
          placeholder="🔍 Search orders..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="filter-tabs">
          <button className={statusFilter === 'all' ? 'tab active' : 'tab'} onClick={() => setStatusFilter('all')}>
            All ({orders.length})
          </button>
          <button className={statusFilter === 'pending' ? 'tab active' : 'tab'} onClick={() => setStatusFilter('pending')}>
            Pending
          </button>
          <button className={statusFilter === 'confirmed' ? 'tab active' : 'tab'} onClick={() => setStatusFilter('confirmed')}>
            Confirmed
          </button>
          <button className={statusFilter === 'shipped' ? 'tab active' : 'tab'} onClick={() => setStatusFilter('shipped')}>
            Shipped
          </button>
          <button className={statusFilter === 'delivered' ? 'tab active' : 'tab'} onClick={() => setStatusFilter('delivered')}>
            Delivered
          </button>
        </div>
      </div>

      {filteredOrders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📋</div>
          <p className="empty-title">No orders found</p>
          <p className="empty-desc">
            {canCreate ? 'Create your first order to get started' : 'No orders available'}
          </p>
          {canCreate && (
            <button onClick={() => navigate('/orders/new')} className="btn-primary" style={{ marginTop: '20px' }}>
              ➕ Create Order
            </button>
          )}
        </div>
      ) : (
        <div className="orders-table-container">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Total</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map(order => (
                <tr key={order.id}>
                  <td className="order-id">#{String(order.id).substring(0, 8)}</td>
                  <td>{order.customer_name || 'N/A'}</td>
                  <td>{formatDate(order.order_date)}</td>
                  <td>TSh {parseFloat(order.total || 0).toFixed(2)}</td>
                  <td>
                    <span className={`status-badge status-${order.status}`}>
                      {order.status}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button className="btn-action-small" onClick={() => navigate(`/orders/${order.id}`)}>
                        View
                      </button>
                      {canEdit && order.status === 'pending' && (
                        <button className="btn-action-small" onClick={() => handleEdit(order)}>
                          Edit
                        </button>
                      )}
                      {canDelete && (
                        <button
                          className="btn-action-small btn-delete"
                          onClick={() => handleDelete(order)}
                          disabled={deleting === order.id}
                        >
                          {deleting === order.id ? '⏳' : '🗑️'}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
    </div>
  );
}

export default OrdersList;